import React from "react";
import { Alert, Space } from "antd";
import { connect } from "react-redux";

const TenantModulosAviso = ({ avisosModulos = [] }) => {
	if (!Array.isArray(avisosModulos) || avisosModulos.length === 0) {
		return null;
	}

	return (
		<div style={{ marginBottom: 12 }}>
			<Space direction="vertical" style={{ width: "100%" }} size={8}>
				{avisosModulos.map((aviso) => {
					const type =
						aviso.expirado || !aviso.vigente ? "error" : "warning";
					return (
						<Alert
							key={`${aviso.id_categoria_permissao}-${aviso.data_fim || "x"}`}
							type={type}
							showIcon
							message={aviso.mensagem}
						/>
					);
				})}
			</Space>
		</div>
	);
};

const mapStateToProps = ({ user }) => ({
	avisosModulos: user.avisosModulos || [],
});

export default connect(mapStateToProps)(TenantModulosAviso);
